export default __webpack_public_path__ + "static/media/lifeleech4.c24cacf5.png";